const $ = (selector) => document.querySelector(selector);

const header = $("#site-header");
const menuButton = $("#menu-button");
const mobileMenu = $("#mobile-menu");
const installButton = $("#install-button");
const installDialog = $("#install-dialog");
const installInstructions = $("#install-instructions");
let installPrompt;

$("#year").textContent = new Date().getFullYear();

const updateHeader = () => header.classList.toggle("scrolled", window.scrollY > 16);
updateHeader();
window.addEventListener("scroll", updateHeader, { passive: true });

menuButton.addEventListener("click", () => {
  const isOpen = menuButton.getAttribute("aria-expanded") === "true";
  menuButton.setAttribute("aria-expanded", String(!isOpen));
  mobileMenu.hidden = isOpen;
});

mobileMenu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => {
  mobileMenu.hidden = true;
  menuButton.setAttribute("aria-expanded", "false");
}));

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPrompt = event;
});

const deviceInstructions = () => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isIOS) return "<ol><li>Open this page in Safari.</li><li>Tap the Share icon.</li><li>Choose <strong>Add to Home Screen</strong>, then tap Add.</li></ol>";
  return "<ol><li>Open your browser menu.</li><li>Choose <strong>Install app</strong> or <strong>Add to Home screen</strong>.</li><li>Confirm to add the Peptide Command icon.</li></ol>";
};

installButton.addEventListener("click", async () => {
  if (installPrompt) {
    installPrompt.prompt();
    await installPrompt.userChoice;
    installPrompt = undefined;
    return;
  }
  installInstructions.innerHTML = deviceInstructions();
  installDialog.showModal();
});

$(".dialog-close").addEventListener("click", () => installDialog.close());
installDialog.addEventListener("click", (event) => {
  if (event.target === installDialog) installDialog.close();
});


const tutorialSource = document.querySelector("#peptide-command-home .tutorial-player source[data-video-src]");
if (tutorialSource) {
  tutorialSource.src = tutorialSource.dataset.videoSrc;
  tutorialSource.closest("video")?.load();
}
